import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { atom } from 'jotai';
import {
  TFindPasswordUserInfo,
  TIsLogin,
  TLoginResponse,
} from 'types/apis/auth';

const sessionStorageConfig = () => sessionStorage;

const sessionStorageAtom = <T>(key: string, defaultValue: T) => {
  const storage = createJSONStorage<T>(sessionStorageConfig);
  return atomWithStorage(key, defaultValue, storage);
};

export const userInfoAtom = sessionStorageAtom<TLoginResponse | null>(
  'userInfo',
  null
);

export const findPasswordUserInfoAtom = atom<TFindPasswordUserInfo>({
  userRole: null,
  loginId: null,
});

export const isLoginAtom = sessionStorageAtom<TIsLogin | null>('isLogin', null);
